import { render, staticRenderFns } from "./AccountOrder.vue?vue&type=template&id=99399d8c&"
import script from "./AccountOrder.vue?vue&type=script&lang=js&"
export * from "./AccountOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports